import { DocumentationFile } from '../../../graphql/graphql';
import { PreviewFile } from '../../../Components/MediaViewer/MediaViewer';

export const prepareDocumentationFileForMediaViewer = (
	item: DocumentationFile,
	socketUrl: string,
) => {
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
	const fileType =
		imageExtensions.indexOf(item?.file?.extension ?? '') !== -1
			? 'image'
			: item?.file?.extension === 'pdf'
			? 'pdf'
			: 'none';
	return {
		id: item.file?.id,
		name: item.name,
		displayName: item.description || item.name || '',
		type: fileType,
		preview:
			socketUrl +
			'/patients/' +
			item.userId +
			'/documentation/' +
			item.folderId +
			'/' +
			item.id +
			'?download=1',
		download:
			socketUrl +
			'/patients/' +
			item.userId +
			'/documentation/' +
			item.folderId +
			'/' +
			item.id +
			'?download=2',
		patient: {
			id: item.userId,
			originalId: item.virtualUser?.originalId,
		},
	} as PreviewFile;
};
